import { Directive, Input, Output, EventEmitter, HostListener } from "@angular/core";
import { NgModule } from '@angular/core';
import { PaymentService } from "../services/payment.service";

@Directive({
    selector: '[clipboard-copy]',
    standalone: false
})
export class ClipboardCopyDirective {

  @Input("clipboard-copy")
  public payload: string;

  @Input("context")
  public context: string;

  @Input("subscription")
  public subscription: PaymentService = null;
 
  @Output("copied")
  public copied: EventEmitter<string> = new EventEmitter<string>();

  @HostListener("click", ["$event"])
  public onClick(event: MouseEvent): void {
    event.preventDefault();
    if (!this.payload)
      return;

    if (this.subscription != null) {
      this.subscription.checkSubscription().then(status=>{
        if (!status) return;  

        this.execCopy(this.payload);
      })
      return;
    }
        
    this.execCopy(this.payload);
  }

  private execCopy(payload) {
    var range = document.createRange();
    range.selectNodeContents(document.body);
    document.getSelection().addRange(range);
    let listener = (e: ClipboardEvent) => {
      let clipboard = e.clipboardData || window["clipboardData"];
      clipboard.setData("text", payload.toString());
      e.preventDefault();
      this.copied.emit(payload);
    };
    document.addEventListener("copy", listener, false);
    document.execCommand("copy");
    document.removeEventListener("copy", listener, false);
    document.getSelection().removeAllRanges();
    if (!document.hasFocus) {
      document['focus']();
    }
  }
}

@NgModule({
  imports: [],
  exports: [ClipboardCopyDirective],
  declarations: [ClipboardCopyDirective],
  providers: [],
})
export class ClipboardModule { }
